import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import {
  getAdminUserList,
  clearUserSearch,
  exportUsers,
} from '../../../../actions/adminActions';
import CustomSelect from '../../shared/CustomSelect';

class UserSearchHorizontal extends Component {
  static propTypes = {
    getAdminUserList: PropTypes.func,
    accounts: PropTypes.instanceOf(Object),
    isSearched: PropTypes.bool,
    clearUserSearch: PropTypes.func,
    userSearchQuery: PropTypes.instanceOf(Object),
    isClearUser: PropTypes.bool,
  };
  static defaultProps = {
    accounts: {},
    isSearched: false,
    isClearUser: false,
    userSearchQuery: {},
  };
  constructor() {
    super();
    this.state = {
      accountOptions: [],
      searchTerm: {
        query: '',
        accountIds: [],
        statusIds: [1, 2, 3, 4],
        loginFrom: '',
        loginTo: '',
        updatedFrom: '',
        updatedTo: '',
        createdFrom: '',
        createdTo: '',
        pageNo: '1',
      },
      clearOptoins: false,
      isExport: {
        success: false,
        error: false,
      },
    };
    this.servicesValue = _.debounce(this.servicesValue, 500);
  }

  UNSAFE_componentWillMount() {
    const { accounts, userSearchQuery } = this.props;
    const accountOptions = [];
    _.map(accounts.data, account => {
      const isTPP = account.accountType === 'TPP' ? true : false;
      accountOptions.push({
        ...account,
        label: isTPP
          ? account.accountName + ' ' + '(Third Party)'
          : account.accountName,
        value: account.accountId,
      });
    });
    this.setState({ accountOptions }, () => {
      this.updateSearchQuery(userSearchQuery);
    });
  }

  UNSAFE_componentWillReceiveProps({
    userSearchQuery,
    isClearUser,
    isSearched,
  }) {
    if (isSearched && !isClearUser) {
      this.updateSearchQuery(userSearchQuery);
    }

    if (!isSearched && isClearUser) {
      this.setState({
        searchTerm: {
          query: '',
          accountIds: [],
          statusIds: [1, 2, 3, 4],
          loginFrom: '',
          loginTo: '',
          updatedFrom: '',
          updatedTo: '',
          createdFrom: '',
          createdTo: '',
          pageNo: '1',
        },
        clearDates: true,
      });
    }
  }

  updateSearchQuery = userSearchQuery => {
    const { searchTerm } = this.state;
    if (!_.isEmpty(userSearchQuery)) {
      const queryObj = _.cloneDeep(userSearchQuery);
      if (!_.isEmpty(queryObj.accountIds)) {
        queryObj.accountIds = queryObj.accountIds;
      }

      if (!_.isEmpty(queryObj.statusIds)) {
        queryObj.statusIds = queryObj.statusIds;
      }
      const updatedSearchTerm = { ...searchTerm, ...queryObj };
      this.setState({ searchTerm: updatedSearchTerm });
    }
  };

  handleAccountChange = accounts => {
    const { searchTerm } = this.state;
    const accountIds = _.map(accounts, a => a.accountId);
    this.setState(
      {
        searchTerm: {
          ...searchTerm,
          accountIds,
        },
        clearOptoins: false,
      },
      () => {
        this.handleSearchUser();
      }
    );
  };

  handleQueryChange = query => {
    const { searchTerm } = this.state;
    this.setState(
      {
        searchTerm: {
          ...searchTerm,
          query,
        },
        clearOptoins: false,
      },
      () => {
        this.servicesValue();
      }
    );
  };

  servicesValue = () => {
    this.handleSearchUser();
  };

  clearQuery = () => {
    const { searchTerm } = this.state;
    this.setState(
      {
        searchTerm: {
          ...searchTerm,
          query: '',
        },
        clearOptoins: false,
      },
      () => {
        this.handleSearchUser();
      }
    );
  };

  handleSearchUser = e => {
    if (e) {
      e.preventDefault();
    }
    const { searchTerm } = this.state;
    this.props.getAdminUserList(searchTerm);
  };

  clearSearch = () => {
    this.setState(
      {
        clearOptoins: true,
      },
      () => {
        this.props.clearUserSearch();
      }
    );
  };

  expotUserList = () => {
    const { accountIds } = this.state.searchTerm;
    this.setState({ isExport: { success: false, error: false } }, () => {
      exportUsers(accountIds).then(res => {
        if (res === 'SUCCESS') {
          this.setState({ isExport: { success: true, error: false } }, () => {
            setTimeout(() => {
              this.setState({ isExport: { success: false, error: false } });
            }, 2000);
          });
        } else {
          this.setState({ isExport: { success: false, error: true } }, () => {
            setTimeout(() => {
              this.setState({ isExport: { success: false, error: false } });
            }, 2000);
          });
        }
      });
    });
  };

  render() {
    const { searchTerm, accountOptions, clearOptoins, isExport } = this.state;
    const { query, accountIds } = searchTerm;
    const { isSearched } = this.props;
    return (
      <div className="user-search user-search--horizontal">
        {isExport.success && (
          <span className="export-message export-success">
            Successfully exported user list. Please see your email.
          </span>
        )}
        {isExport.error && (
          <span className="export-message export-error">
            Unable to exported selected user list at this time, please try again
            later.
          </span>
        )}
        <form onSubmit={this.handleSearchUser}>
          <div className="user-search--box">
            <div className="user-search--form">
              <div className="user-search--form-group">
                <label className="sr-only" htmlFor="searchQuery">
                  Search by first name or last name or email...
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={query}
                  id="searchQuery"
                  name="searchQuery"
                  onChange={e => this.handleQueryChange(e.target.value)}
                  placeholder="Search by first name or last name or email..."
                  autoComplete="off"
                />
                {query && (
                  <button
                    type="button"
                    onClick={this.clearQuery}
                    className="user-search--form-clear"
                  >
                    <i className="clear-x-icon" />
                  </button>
                )}
              </div>
              <div className="user-search--form-group user-search--form-dropdown">
                <label className="sr-only" htmlFor="searchAccounts">
                  Search by Accounts
                </label>
                <CustomSelect
                  options={accountOptions}
                  onChange={this.handleAccountChange}
                  clearOptoins={clearOptoins}
                  defaultSelectedItem={this.props.userSearchQuery.accountIds}
                  placeholder="All Accounts"
                  id="searchAccounts"
                  name="searchAccounts"
                  multi
                />
              </div>
            </div>
            <div className="user-search--form--footer">
              <div>
                {isSearched && accountIds.length === 1 && (
                  <button
                    type="button"
                    onClick={this.expotUserList}
                    className="button primary"
                    title="Export user list into excel"
                  >
                    Export
                  </button>
                )}
                {isSearched && (
                  <button
                    type="button"
                    onClick={this.clearSearch}
                    className="button primary"
                    title="Clear Search"
                  >
                    Clear
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = ({ admin }) => {
  return {
    userSearchQuery: admin.userSearchQuery,
    isClearUser: admin.isClearUser,
    isSearched: admin.isSearched,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAdminUserList: bindActionCreators(getAdminUserList, dispatch),
    clearUserSearch: bindActionCreators(clearUserSearch, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSearchHorizontal);
